import { render, staticRenderFns } from "./CarriersAndTrucks.vue?vue&type=template&id=1d58d0e2&scoped=true"
import script from "./CarriersAndTrucks.vue?vue&type=script&lang=js"
export * from "./CarriersAndTrucks.vue?vue&type=script&lang=js"
import style0 from "./CarriersAndTrucks.vue?vue&type=style&index=0&id=1d58d0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58d0e2",
  null
  
)

export default component.exports